export interface AWSError {
  code: string;
  name: string;
  message: string;
}

export function isAWSError(responseFromApi: AWSError | string): responseFromApi is AWSError {
  return (responseFromApi as AWSError).code !== undefined;
}
